import { render } from "./List.vue?vue&type=template&id=b0f59664"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/bylex_platform/cwt2/alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/TasksTypes/List.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b0f59664"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b0f59664', __exports__)) {
    api.reload('b0f59664', __exports__)
  }
  
  module.hot.accept("./List.vue?vue&type=template&id=b0f59664", () => {
    api.rerender('b0f59664', render)
  })

}


export default __exports__